// @flow
import type { IdealistDayEvent as ApiIdealistDayEvent } from 'api/userDashboard';
import type { Action } from '../../actions/userDashboard/idealistDayEvents';

export type IdealistDayEvent = {
  ...$Exact<ApiIdealistDayEvent>,
  isFetching: boolean
};

export type State = {
  byId: {
    [string]: {
      ...IdealistDayEvent,
      isFetching: boolean
    }
  },
  list: {
    idealistDayEventIds?: Array<string>,
    isFetching: boolean
  }
};

export default function events(
  state: State = {
    byId: {},
    list: { isFetching: false }
  },
  action: Action
) {
  switch (action.type) {
    case 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.eventId]: {
            ...state.byId[action.eventId],
            id: action.eventId,
            isFetching: true
          }
        }
      };
    case 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_SUCCESS': {
      let idealistDayEventIds = state.list.idealistDayEventIds || [];
      if (!idealistDayEventIds.includes(action.event.id)) {
        idealistDayEventIds = [...idealistDayEventIds, action.event.id];
      }
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.event.id]: {
            ...action.event,
            isFetching: false
          }
        }
      };
    }
    case 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_REQUEST':
      return {
        ...state,
        list: {
          ...state.list,
          isFetching: true
        }
      };
    case 'USER_DASHBOARD_FETCH_IDEALIST_DAY_EVENTS_SUCCESS': {
      const newState = { ...state };
      action.events.forEach(event => {
        newState.byId[event.id] = { ...event, isFetching: false };
      });
      newState.list = {
        idealistDayEventIds: action.events.map<string>(e => e.id),
        isFetching: false
      };
      return newState;
    }
    case 'USER_DASHBOARD_CLEAR_IDEALIST_DAY_EVENTS':
      return {
        ...state,
        list: {
          isFetching: false
        }
      };
    case 'USER_DASHBOARD_REMOVE_IDEALIST_DAY_EVENT': {
      const { eventId } = action;
      const eventIds = state.list.idealistDayEventIds || [];
      const idealistDayEventIds: Array<string> = eventIds.filter(
        id => id !== eventId
      );
      return {
        ...state,
        list: {
          ...state.list,
          idealistDayEventIds
        }
      };
    }
    default:
      // this causes a flow error if there are any unhandled actions
      (action: empty); // eslint-disable-line no-unused-expressions
      return state;
  }
}
